module.exports = __webpack_public_path__ + "img/section1.7eca8d0e.png";